import { required } from 'vuelidate/lib/validators'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

const defaultEl = {
  id: null,
  name: {},
  tooltip: {},
  from_date_period_id: null,
  to_date_period_id: null
};

export default {
  name: 'PeriodicNameEdit',
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  props: {
    modelClassId: {
      default: null,
      type: String | Number
    },
    modelId: {
      default: null,
      type: String | Number
    }
  },
  validations: {
    editEl: {
      name: { required },
      tooltip: { },
      from_date_period_id: { required },
      to_date_period_id: { }
    }
  },
  components: {
    DatePeriodPicker
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.config.periodicnames.edit');
      }
      return this.$t('menu.config.periodicnames.new');
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings') && !this.loading;
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        reqData.model_class_id = this.modelClassId;
        reqData.model_element_id = this.modelId;
        const self = this;
        this.ApiRequest.request('periodic-name/edit', this.ApiRequest.REQUEST_POST, { item: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
            self.$store.dispatch('reloadConfig', { force: true });
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
